import React from "react";

export default function FieldStatus_PopoverMore(props:any) {

    const taskTypeId = props.listItem.item.taskTypeId

    console.warn("TO FIX #40923148723984723")

    return (
        <div className="help">
            <div className="ui5-link-small" onClick={()=>{
                props.parent.hidePopover();
                gd.goTo(`settings/task-types/${taskTypeId}`);
            }}>Edit workflow</div>
        </div>

    );
}
